// extracted by mini-css-extract-plugin
export default {"image":"userAvatar_image__wyTF1","fallback":"userAvatar_fallback__mAFvG","inner":"userAvatar_inner__VdvYF","glyph":"userAvatar_glyph__X5dMl"};